import { render, staticRenderFns } from "./EditSidebar.vue?vue&type=template&id=231c96b0&scoped=true&"
import script from "./EditSidebar.vue?vue&type=script&lang=js&"
export * from "./EditSidebar.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/document_edit.scss?vue&type=style&index=0&id=231c96b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231c96b0",
  null
  
)

export default component.exports